import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const communicationColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Out-of-state Contact Person Communication Plan": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phoneNumber",
        render: (record) => (record ? record : "N/A"),
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
        render: (record) => (record ? record : "N/A"),
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
        render: (record) => (record ? record : "N/A"),
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
        render: (record) => (record ? record : "N/A"),
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Relationship",
        dataIndex: "Relationship",
        key: "relationship",
        render: (record) => (record ? record : "N/A"),
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],

    "Social Media Accounts": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Account",
        dataIndex: "Who's Account",
        key: "Who's Account",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "User ID",
        dataIndex: "User Id",
        key: "userid",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Password",
        dataIndex: "Password",
        key: "passowrd",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Emergency Alert Subscriptions": [
      {
        title: "Company",
        dataIndex: "Company",
        key: "company",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phone number",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Account Number",
        dataIndex: "Account Number",
        key: "account number",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Backup Communication Devices": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
  };
};
